// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable prefer-rest-params, babel/camelcase */
import * as R from "ramda"
import type { PriceType } from "@kiwicom/nitro/lib/records/Price"

export type PriceParamsServer = {
  amount: string
  base: string
  service: string
  service_flat: string
  merchant: string
  currency: string
}

export type PriceParams = {
  amount: number
  base?: number
  service?: number
  serviceFlat?: number
  merchant?: number
  currency?: string
}

const DEFAULT_CURRENCY = "eur"
const PRICE_COMPONENTS = ["amount", "base", "service", "serviceFlat", "merchant"]

export type SimplePrice = {
  /**
   * Amount of money.
   * @type {string}
   * @memberof SimplePrice
   */
  amount: string
  /**
   * Price currency, 3 letter currency code as defined by ISO-4217.
   * @type {string}
   * @memberof SimplePrice
   */
  currency: string
}

export default class Price {
  amount: number

  base: number

  service: number

  serviceFlat: number

  merchant: number

  currency: string

  constructor({ amount, base, currency, service, serviceFlat, merchant }: PriceParams) {
    if (!R.is(Number, amount)) {
      throw new Error("'amount' is not number")
    }

    this.amount = amount
    this.base = typeof base === "number" && !Number.isNaN(base) ? base : amount
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    this.service = service || 0
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    this.serviceFlat = serviceFlat || 0
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    this.merchant = merchant || 0
    this.currency = currency ? currency.toLowerCase() : DEFAULT_CURRENCY
  }

  get ourService() {
    return this.service + this.serviceFlat
  }

  get totalService() {
    return this.ourService + this.merchant
  }

  static sum(input: (Price | PriceType)[]): Price {
    const prices: (Price | PriceType)[] = Array.isArray(input) ? input : Array.from(arguments)
    const involvedCurrencies = R.pipe(R.pluck("currency"), R.uniq)(prices)

    if (involvedCurrencies.length > 1) {
      throw new Error("Unable sum prices with different currencies")
    }

    return new Price(
      // @ts-expect-error: Flow to TS migration.
      R.pipe(
        // Fix this the next time the file is edited. (Flow to TS)
        // @ts-expect-error: Flow to TS migration.
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        R.map((x) => [x, prices.reduce((acc, y) => acc + R.prop(x, y), 0)]),
        // @ts-expect-error: Flow to TS migration.
        R.fromPairs,
        R.assoc("currency", R.head(involvedCurrencies)),
      )(PRICE_COMPONENTS),
    )
  }

  static multiply(price: Price, multiplier: number) {
    return new Price({
      amount: price.amount * multiplier,
      base: price.base * multiplier,
      currency: price.currency,
      service: price.service * multiplier,
      serviceFlat: price.serviceFlat * multiplier,
      merchant: price.merchant * multiplier,
    })
  }

  static toServer(price: Price | PriceType): PriceParamsServer {
    return {
      amount: price.amount.toFixed(2).toString(),
      base: price.base.toFixed(2).toString(),
      service: price.service.toFixed(2).toString(),
      service_flat: price.serviceFlat.toFixed(2).toString(),
      merchant: price.merchant.toFixed(2).toString(),
      currency: price.currency.toUpperCase(),
    }
  }

  static fromServer(priceParamsServer: PriceParamsServer | SimplePrice): Price {
    return new Price({
      amount: Number(priceParamsServer.amount),
      // @ts-expect-error: Flow to TS migration.
      base: Number(priceParamsServer.base || "0"),
      // @ts-expect-error: Flow to TS migration.
      service: Number(priceParamsServer.service || "0"),
      // @ts-expect-error: Flow to TS migration.
      serviceFlat: Number(priceParamsServer.service_flat || "0"),
      // @ts-expect-error: Flow to TS migration.
      merchant: Number(priceParamsServer.merchant || "0"),
      currency: priceParamsServer.currency,
    })
  }
}
